import { render, staticRenderFns } from "./SignaturePadWrapper.vue?vue&type=template&id=4600bfe0&"
import script from "./SignaturePadWrapper.vue?vue&type=script&lang=ts&"
export * from "./SignaturePadWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports